import tw from "twin.macro";
import Button from "app/components/Button";
import { ReactComponent as CloseIcon } from "app/assets/icons/close.svg";
import Text from "app/styles/Text";
import { BUSHA_URL } from "app/constants/variables";
import { ReactComponent as BushaLogo } from "app/assets/logo/busha-logo.svg";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";

interface Props {
  onClose: () => void;
  isOpen: boolean;
  onPayWithCryptoWallet: () => void;
  currency: string;
}
export default function InsufficientBalanceModal(props: Props) {

  return (
    <Dialog open={props.isOpen} onClose={props.onClose} tw="relative z-50">
      <DialogBackdrop tw="fixed inset-0 bg-[#21292133] backdrop-blur-[27px]" />

      <div tw="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel tw="bg-containment-primary p-[20px] rounded-[20px] w-full max-w-[500px] flex flex-col gap-[24px]">
          <div tw="flex flex-col gap-[16px]">
            <div tw="flex items-center justify-between">
              <Text css={tw`headline-medium`}>
                Insufficient {props.currency} balance
              </Text>

              <button
                aria-label="Close cancel modal"
                type="button"
                tw="bg-containment-tertiary rounded-full h-[32px] w-[32px] flex items-center justify-center"
                onClick={props.onClose}
              >
                <CloseIcon tw="w-[16px] h-[16px]" />
              </button>
            </div>

            <Text css={tw`body-large text-text-mid`}>
              Your {props.currency} balance is insufficient to complete this transaction. Please select a different wallet or switch payment method.
            </Text>
          </div>

          <div tw="flex flex-col gap-[16px]">
            <Button
              fullWidth
              size="xBig"
              variant="primary"
              text="Change wallet"
              onClick={props.onClose}
            />

            <Button
              fullWidth
              size="xBig"
              variant="secondary"
              text="Pay with crypto wallet"
              onClick={props.onPayWithCryptoWallet}
            />
          </div>

          <div tw="flex gap-[16px] items-center justify-center">
            <div tw="flex items-center gap-[8px]">
              <Text css={tw`text-text-mid label-xl`}>Secured by</Text>
              <a aria-label="Secured by Busha" href={BUSHA_URL} target="_blank" rel="noopener noreferrer">
                <BushaLogo />
              </a>
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
